<template>
    <div></div>
</template>

<script>
import WS from '@/utils/webSocket.js'

export default {

    data() {
        return {
            loginUser: {},
        }
    },

    mounted() {
    
        this.getAccountName();

        //获取全局唯一实例
        this.socket = WS.getInstance();
        //初始化连接(全局仅初始化一次)
        this.socket.init();

        //接收后端推送消息-保证各组件中函数名(this.notification)唯一性
        this.notification = (data) => {

            //console.log('收到消息:', data);
            
            //后厨隐藏通知
            if( this.loginUser.account === 'admin' ) {

                //出餐提醒
                if( data.type === 'chef' ) {
                
                    this.$notify({
                        title: data.tableNum || '外送 #' + data.code,
                        message: data.tableNum ? '可以出餐啦！' : '可以派送啦！',
                        duration: 0,
                        type: 'success'
                    });

                    //提示音
                    new Audio('/audio/remind.mp3').play();

                };


                //来单提醒
                if( data.type === 'newOrder' ) {

                    this.$notify({
                        title: '待接单',
                        message: data.tableSite ? `${data.tableSite} ${data.orderNo}` : `外送 #${data.code} ${data.orderNo}`,
                        duration: 0,
                    });

                    //语音播报
                    new Audio('/audio/new_order.mp3').play();

                };


                //催单提醒
                if( data.type === 'reminder' ) {

                    this.$notify({
                        title: '客户催单',
                        message: data.tableSite ? `${data.tableSite} ${data.orderNo}` : `外送 #${data.code} ${data.orderNo}`,
                        duration: 0,
                    });

                    //语音播报
                    new Audio('/audio/reminder.mp3').play()

                };

                //订单取消
                if( data.type === 'cancel') {
                
                    this.$notify({
                        title: '退单',
                        // message: data.tableSite + ', ' + data.name,
                        duration: 0,
                    });

                    //提示音
                    new Audio('/audio/cancel_order.mp3').play();

                };

            };

            //前台隐藏通知
            if( this.loginUser.account === '后厨' ) {

                //后厨任务提醒
                if( data.type === 'task') {
                
                    this.$notify({
                        // title: '前台提醒',
                        title: '后厨任务',
                        // message: data.tableSite + '--------' + '新菜品',
                        message: data.tableSite,
                        duration: 0,
                    });

                    //提示音
                    new Audio('/audio/remind.mp3').play();

                };


                //退菜提醒
                if( data.type === 'return') {
                
                    this.$notify({
                        title: '退菜',
                        message: data.tableSite + ', ' + data.name,
                        duration: 0,
                    });

                    //提示音
                    new Audio('/audio/remind.mp3').play();

                };

                
            }

            
        };

        //注册监听-传递到ws内部的onMessage
        this.socket.onMessage(this.notification);
    },

    beforeDestroy() {
        //销毁
        this.socket.offMessage(this.notification);
    },

    methods: {

        //获取登录的账号名
        getAccountName() {

            //从本地获取到登录的账号名
            // const strAccountName = localStorage.getItem('loginUser');
            
            //去除自带的""双引号
            // let accountName = JSON.parse(strAccountName);

            // if( accountName === 'admin' || accountName === '后厨' ) {
            //     this.loginUser.account = accountName;
            // }

            //从本地获取到登录的账号名
            const accountName = localStorage.getItem('loginUser');

            if( accountName === 'admin' || accountName === '后厨' ) {
                this.loginUser.account = accountName;
            }
            
        },

      

        playOrderAudio() {

            // this.orderAudio.pause(); //暂停正在播放的音频

            // this.orderAudio.currentTime = 0; //重置音频播放进度,为0起始位

            this.orderAudio.play().actch(err => {
                console.log(err);
                
            }); //播放

            //new Audio('').play(); //触发空音频,启动 交给admin登录时触发
        },

    }

}
</script>

<style>
    .el-notification {
        border-radius: 5px;
    }

    /* .el-notification .el-icon-success {
        color: #df0000;
    } */

    .el-notification__title {
        font-size: 15px;
    }

</style>